// extracted by mini-css-extract-plugin
export var item = "itemList-module--item--aoJIX";
export var item_iconWrap = "itemList-module--item_iconWrap--Bfu1H";
export var item_title = "itemList-module--item_title--1tueY";